import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  addressInfo: {
    countryCode: 'TR',
    countryName: 'Türkiye',
    telephoneCountryCode: '90',
    telephoneAreaCode: '',
    telephone: '',
    companyName: '',
    contactPerson: '',
    email: '',
    zipCode: '',
    address: '',
    customerowner: false,
  },
  companyInfo: {
    telephoneCountryCode: '90',
    mobileCountryCode: '90',
    customerId: '',
    address: '',
    companyName: '',
    contactPerson: '',
    telephone: '',
    telephoneAreaCode: '',
    mobile: '',
    mobileAreaCode: '',
    identityNumber: '',
    taxNumber: '',
    taxOffice: '',
    zipCode: '',
    email: '',
  },
};

export const addressSlice = createSlice({
  name: 'address',
  initialState,
  reducers: {
    updateAddressInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.addressInfo[field] = value;
    },
    updateCompanyInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.companyInfo[field] = value;
    },
    updateCompanyInfo: (state, action) => {
      state.companyInfo = action.payload;
    },
    updateAddressInfo: (state, action) => {
      state.addressInfo = action.payload;
    },
    resetAddressInfo: (state) => {
      state.addressInfo = initialState.addressInfo;
    },
    resetCompanyInfo: (state) => {
      state.companyInfo = initialState.companyInfo;
    },
  },
});

export const addressInfoSelector = (state) => state.address.addressInfo;
export const companyInfoSelector = (state) => state.address.companyInfo;
export const isDistrictNameRequiredSelector = (state) => {
  return (
    (state.address.addressInfo?.countryCode === 'US' ||
      state.address.addressInfo?.countryCode === 'CA') &&
    state.address.addressInfo?.customerowner
  );
};
export const {
  updateAddressInfoField,
  updateCompanyInfoField,
  updateCompanyInfo,
  updateAddressInfo,
  resetAddressInfo,
  resetCompanyInfo,
} = addressSlice.actions;

export const addressReducer = addressSlice.reducer;
export const addressReducerName = addressSlice.name;

export default addressSlice.reducer;
